module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Thin-Italic.d4861370.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Thin-Italic.otf
// module id = 2372
// module chunks = 49